export class HandwriterError extends Error {
  constructor(
    message: string,
    public readonly userMessage: string,
    public readonly code: string,
  ) {
    super(message);
    this.name = 'HandwriterError';
  }
}

export class OcrError extends HandwriterError {
  constructor(code: OcrErrorCode, userMessage: string, detail?: string) {
    super(detail ?? userMessage, userMessage, code);
    this.name = 'OcrError';
  }
}

export type OcrErrorCode =
  | 'invalid_key'
  | 'quota_exceeded'
  | 'illegible'
  | 'parse_failed'
  | 'network'
  | 'unknown';

export class UploadError extends HandwriterError {
  constructor(code: UploadErrorCode, userMessage: string, detail?: string) {
    super(detail ?? userMessage, userMessage, code);
    this.name = 'UploadError';
  }
}

export type UploadErrorCode =
  | 'auth'
  | 'network'
  | 'server'
  | 'rate_limited'
  | 'payload_too_large'
  | 'validation'
  | 'unknown';
